const RTL_LOCALES = new Set(['ar-PS', 'ug'])

export default RTL_LOCALES
